'use client'

import React from 'react'
import { CookieBanner, CompactCookieBanner } from './CookieBanner'
import { CookiePreferencesModal } from './CookiePreferencesModal'
// import { useCookieConsent } from '@/context/cookie-consent-context/CookieConsentContext'

export function CookieConsentWrapper() {
  // const { showBanner, consent } = useCookieConsent()
  
  // // Temporary debug info (remove after fixing)
  // if (process.env.NODE_ENV === 'development') {
  //   console.log('🎯 CookieConsentWrapper Debug:', {
  //     showBanner,
  //     hasConsent: !!consent,
  //     consent
  //   })
  // }

  return (
    <>
      {/* Debug info in development */}
      {/* {process.env.NODE_ENV === 'development' && (
        <div style={{
          position: 'fixed',
          top: '10px',
          right: '10px',
          background: 'black',
          color: 'white',
          padding: '8px',
          fontSize: '12px',
          zIndex: 9999,
          borderRadius: '4px'
        }}>
          Banner: {showBanner ? '✅' : '❌'} | Consent: {consent ? '✅' : '❌'}
        </div>
      )} */}
      
      {/* Desktop Banner */}
      <div className="hidden sm:block">
        <CookieBanner />
      </div>
      
      {/* Mobile Banner */}
      <div className="block sm:hidden">
        <CompactCookieBanner />
      </div>
      
      {/* Preferences Modal */}
      <CookiePreferencesModal />
    </>
  )
}

export default CookieConsentWrapper 